import asReduxFormField from '@common/components/FormElements/asReduxFormField';
import { Section } from '@common/components/BookingForms';
import { SpaPackageType } from 'shared-types/SpaPackage';
import React, { FC, useEffect } from 'react';
import { Field } from 'redux-form';
import { DateSelector } from './DateSelector';
import { FormBox } from './DateTimeSelector.styles';
import { TimeslotSelector } from './TimeslotSelector';

const TimeslotSelectorField = asReduxFormField(TimeslotSelector);
const DateSelectorField = asReduxFormField(DateSelector);

export type DateTimeSelectorProps = {
  entity: SpaPackageType;
  onStartDateChange: (startDate: string) => void;
  selectedDate: string;
  selectedTime: { label: string; value: string } | undefined;
  loadingDates: string[];
  clearTimeSlots: () => void;
  isLoading: boolean;
  hideArrivalTimes: boolean;
  change: (field: string, value: string) => void;
};

export const DateTimeSelector: FC<DateTimeSelectorProps> = ({
  entity,
  loadingDates,
  onStartDateChange,
  selectedDate,
  selectedTime,
  clearTimeSlots,
  isLoading,
  hideArrivalTimes,
  change,
}) => {
  const { supportsTimeslots = false, timeslots = [] } = entity || {};

  useEffect(() => {
    if (selectedDate) {
      clearTimeSlots();
      const availableTimeslots = timeslots?.[selectedDate];
      if (availableTimeslots?.length > 0) {
        change('arrivalTime', availableTimeslots[0]);
      }
    }
  }, [selectedDate]);

  return (
    <Section>
      <FormBox>
        <Field
          name="date"
          component={DateSelectorField}
          entity={entity}
          onStartDateChange={onStartDateChange}
          loadingDates={loadingDates}
          selectedDate={selectedDate}
          isLoading={isLoading}
        />
        <Field
          name="arrivalTime"
          component={TimeslotSelectorField}
          display={supportsTimeslots && !hideArrivalTimes}
          timeslotOptions={timeslots?.[selectedDate]}
          selectedTime={selectedTime}
          clearTimeSlots={clearTimeSlots}
        />
      </FormBox>
    </Section>
  );
};
